import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  showContent(event) {
    const selectedValue = event.target.value;
    this.contentTargets.forEach((content) => {
      if (content.dataset.radioValue === selectedValue) {
        content.classList.remove("hidden");
      } else {
        content.classList.add("hidden");
      }
    });
  }
}
